import type { IntegrationSuggestion } from '@/features/integrations/integrations.types';

export interface SuggestionDevice {
  runs: (platforms: IntegrationSuggestion['platforms']) => boolean;
  installed: ReadonlySet<string>;
}

export function visibleSuggestions(
  suggestions: readonly IntegrationSuggestion[],
  device: SuggestionDevice
): IntegrationSuggestion[] {
  return suggestions.filter(
    (suggestion) =>
      suggestion.provider !== 'on_device' ||
      (device.runs(suggestion.platforms) &&
        !device.installed.has(suggestion.toolkit_slug))
  );
}
